<div id="t-content-center">
  <div id="content">
    <ng-content select="[slotContent]"></ng-content>
  </div>
</div>
